import styled from 'styled-components';

interface bredcrumbListProps {
	margin?: string;
}
const BredcrumbList = styled.ul<bredcrumbListProps>`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    margin: ${({ margin }) => margin};
}
`;

export default BredcrumbList;
